// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__5tELQ","range":"MonthRangeSwitch_range__33KCi","disabled":"MonthRangeSwitch_disabled__3zZb2"};